module.exports = __webpack_public_path__ + "img/login-v2.a48536af.svg";